
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { TopBar } from "@/shared/widgets/layout/TopBar";
import { Footer } from "@/shared/widgets/layout/Footer";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-[#1A1A1A]">
      <TopBar />
      <main className="mx-auto w-[1136px] max-w-full px-4 py-8">
        <div className="flex items-center justify-center min-h-[60vh]">
          <div className="text-center">
            <h1 className="text-6xl font-bold mb-4 text-white">404</h1>
            <p className="text-xl text-white/60 mb-6">Oops! Página não encontrada</p>
            <a 
              href="/" 
              className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-[#D91657] text-white hover:bg-[#D91657]/90 transition-colors"
            >
              Voltar para o início
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
